// Portado 1:1 de `blockedQs.ts` na raiz do repo original (Deno/Fresh), onde era
// passado para `unstable_blockUseSectionHrefQueryStrings(blockedQs)` em
// `apps/site.ts` — hook que o framework aplica em `createStableHref` (o href do
// `useSection`). Como a grade da PLP é uma section deferred, em produção os
// links de paginação/ordenação nascem desse href já filtrado.
//
// Aqui `useSection` é um stub legado (partials morreram na migração), então a
// lista é aplicada nos montadores de link — ver src/sdk/stripTrackingParams.ts.
//
// Mantenha diffável contra o original: só acrescente em EXTRA_BLOCKED_QS.
export const blockedQs = [
    'PS',
    'gad_source',
    'gclid',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_term',
    'utm_smid',
    // 'idsku',
    // 'fresh-partial',
    'fbclid',
    'gbraid',
    'hl',
    'trustvox_answer_id',
    'trustvox_product_id',
    'trustvox_user_id',
    'trustvox_user_token',
    'm_token',
    't',
    'bqreferrer',
    'utm_source_platform',
    'utm_creative_format',
    'utm_marketing_tactic',
    'utm_id',
    // 'postalCode',
    'wbraid',
    'name',
    'email',
    'btg_flag',
    'btg_source',
    'AF',
    'gRefinements',
    'umt_campaign',
    'bqopen',
]

// Lista built-in do @deco/deco (hooks/mod.ts), derivada do Cloudflare APO:
// https://developers.cloudflare.com/automatic-platform-optimization/reference/query-parameters
// Em produção ela vale junto com a lista acima, porque `addBlockedQS` só faz
// `BLOCKED_QS.add(...)` sobre este conjunto.
export const frameworkBlockedQs = [
    'ref',
    'fbclid',
    'fb_action_ids',
    'fb_action_types',
    'fb_source',
    'mc_cid',
    'mc_eid',
    'gclid',
    'dclid',
    '_ga',
    'campaignid',
    'adgroupid',
    '_ke',
    'cn-reloaded',
    'age-verified',
    'ao_noptimize',
    'usqp',
    'mkt_tok',
    'epik',
    'ck_subscriber_id',
]

// Nossa extensão (não existe no original), em dois grupos:
//
// 1. PII em pt-BR, que a auditoria da DECO-5819 cita explicitamente
//    ("email, nome"). O original só bloqueia as chaves em inglês
//    `name`/`email`.
//
// 2. Tracking params ausentes das listas de cima, que fragmentavam a chave
//    do edge E a do cachedLoader (via canonicalizeCacheProps). O pior é
//    `srsltid`: o Google anexa um valor ÚNICO POR IMPRESSÃO nos links de
//    resultados orgânicos/Shopping, então cada clique virava uma entrada de
//    cache nova e pagava o cold render inteiro. Nenhum deles colide com o
//    conjunto funcional de src/ (O, __sku, fresh-partial, idsku, map, page,
//    payload, q, skuId, t).
export const EXTRA_BLOCKED_QS = [
    'nome',
    'sobrenome',
    'telefone',
    'celular',
    'cpf',
    'cnpj',
    'senha',
    'srsltid',
    '_gl',
    'msclkid',
    'ttclid',
    'twclid',
    'yclid',
    'igshid',
    'mibextid',
    'gclsrc',
    'gad_campaignid',
    'sca_esv',
]
